export enum Role {
  Admin = 'admin',
  ClinicManager = 'clinic_manager',
  Consultant = 'consultant',
  OrgUser = 'org_user',
}
